// File: assets/dwell-scrolling-gallery.js
// Dwell Scrolling Gallery JavaScript
(function() {
  'use strict';
  
  const galleries = new Map();
  
  // Initialize gallery
  function initGallery(sectionId) {
    const container = document.getElementById(`gallery-${sectionId}`);
    const track = document.getElementById(`track-${sectionId}`);
    
    if (!container || !track) return;
    
    const items = track.querySelectorAll('.gallery-item');
    if (items.length === 0) return;
    
    // Initialize gallery state
    galleries.set(sectionId, {
      items: items,
      currentIndex: 0,
      totalItems: items.length,
      interval: null,
      duration: 3000 // 3 seconds
    });
    
    // Start the gallery
    updateGallery(sectionId);
    startAutoScroll(sectionId);
    
    // Add touch support
    addTouchSupport(sectionId, track);
  }
  
  // Update gallery positions
  function updateGallery(sectionId) {
    const gallery = galleries.get(sectionId);
    if (!gallery) return;
    
    const { items, currentIndex, totalItems } = gallery;
    
    // Clear all position classes
    items.forEach(item => {
      item.className = 'gallery-item';
    });
    
    // Position items
    items.forEach((item, index) => {
      const relativeIndex = (index - currentIndex + totalItems) % totalItems;
      
      if (relativeIndex === 0) {
        item.classList.add('center');
      } else if (relativeIndex === 1 || relativeIndex === totalItems - 1) {
        item.classList.add(relativeIndex === 1 ? 'right-1' : 'left-1');
      } else if (relativeIndex === 2 || relativeIndex === totalItems - 2) {
        item.classList.add(relativeIndex === 2 ? 'right-2' : 'left-2');
      } else {
        item.classList.add(relativeIndex < totalItems / 2 ? 'right-stack' : 'left-stack');
      }
    });
  }
  
  // Start auto-scroll
  function startAutoScroll(sectionId) {
    const gallery = galleries.get(sectionId);
    if (!gallery) return;
    
    stopAutoScroll(sectionId); // Clear any existing intervals
    
    // Simple interval - always playing
    gallery.interval = setInterval(() => {
      nextSlide(sectionId);
    }, gallery.duration);
  }
  
  // Stop auto-scroll
  function stopAutoScroll(sectionId) {
    const gallery = galleries.get(sectionId);
    if (!gallery) return;
    
    if (gallery.interval) {
      clearInterval(gallery.interval);
      gallery.interval = null;
    }
  }
  
  // Next slide
  function nextSlide(sectionId) {
    const gallery = galleries.get(sectionId);
    if (!gallery) return;
    
    gallery.currentIndex = (gallery.currentIndex + 1) % gallery.totalItems;
    updateGallery(sectionId);
  }
  
  // Previous slide
  function prevSlide(sectionId) {
    const gallery = galleries.get(sectionId);
    if (!gallery) return;
    
    gallery.currentIndex = (gallery.currentIndex - 1 + gallery.totalItems) % gallery.totalItems;
    updateGallery(sectionId);
  }
  
  // Expand image
  window.expandImage = function(imageSrc, imageAlt) {
    const modal = document.querySelector('.image-modal');
    const modalImage = modal.querySelector('.modal-image');
    
    modalImage.src = imageSrc;
    modalImage.alt = imageAlt;
    modal.style.display = 'block';
    
    document.body.style.overflow = 'hidden';
  };
  
  // Close expanded image
  window.closeExpanded = function(sectionId) {
    const modal = document.querySelector('.image-modal');
    modal.style.display = 'none';
    document.body.style.overflow = '';
  };
  
  // Add touch support
  function addTouchSupport(sectionId, track) {
    let startX = 0;
    let endX = 0;
    
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    track.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    }, { passive: true });
    
    track.addEventListener('touchend', () => {
      const diff = startX - endX;
      const minSwipeDistance = 50;
      
      if (Math.abs(diff) > minSwipeDistance) {
        // Temporarily stop auto-scroll when user interacts
        stopAutoScroll(sectionId);
        
        if (diff > 0) {
          nextSlide(sectionId);
        } else {
          prevSlide(sectionId);
        }
        
        // Restart auto-scroll after user interaction
        setTimeout(() => {
          startAutoScroll(sectionId);
        }, 2000);
      }
    }, { passive: true });
  }
  
  // Close modal on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const modal = document.querySelector('.image-modal');
      if (modal && modal.style.display === 'block') {
        closeExpanded();
      }
    }
  });
  
  // Initialize all galleries
  function initAllGalleries() {
    const galleryElements = document.querySelectorAll('.dwell-scrolling-gallery');
    galleryElements.forEach(gallery => {
      const sectionId = gallery.id.replace('gallery-', '');
      initGallery(sectionId);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }
  
  // Handle section loads/unloads for theme editor
  document.addEventListener('shopify:section:load', (e) => {
    const gallery = e.target.querySelector('.dwell-scrolling-gallery');
    if (gallery) {
      const sectionId = gallery.id.replace('gallery-', '');
      setTimeout(() => initGallery(sectionId), 100);
    }
  });
  
  document.addEventListener('shopify:section:unload', (e) => {
    const gallery = e.target.querySelector('.dwell-scrolling-gallery');
    if (gallery) {
      const sectionId = gallery.id.replace('gallery-', '');
      stopAutoScroll(sectionId);
      galleries.delete(sectionId);
    }
  });
  
})();
